import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SeleccionPeriodoTitulacionComponent } from '../seleccion-periodo-titulacion.component';

@Component({
  selector: 'app-compo-seleccion-periodo-titulacion',
  templateUrl: './compo-seleccion-periodo-titulacion.component.html',
  styleUrls: ['./compo-seleccion-periodo-titulacion.component.scss']
})
export class CompoSeleccionPeriodoTitulacionComponent {
  @Input() periodoForm!: FormGroup;

  constructor(public translate: TranslateService,
    public dialog: MatDialog,
    private fb: FormBuilder) {
  }

  ngOnInit() {
    if (this.periodoForm !== undefined)
      this.periodoForm.addControl("periodoAcademico", new FormControl('', Validators.required));
  }
  verPeriodo() {
    setTimeout(() => {
      const dialogRef = this.dialog.open(SeleccionPeriodoTitulacionComponent, {
        width: '50%',
        data: null
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result !== null) {
          this.periodoForm.get('periodoAcademico')!.setValue(result.data.academicYear + '/' + result.data.academicTerm + '/' + result.data.academicSession);
        }
      });
    }, 300);
  }


}
